import { ExpandMore } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { DropdownMenu, DropdownToggle, Label, UncontrolledDropdown } from "reactstrap";
import { ISelectOption } from "../forms/util";
import { takeFiveRoute, takeFiveOverviewPathRoute, takeFivePathRoute, takeFiveSectionPathRoute, takeFiveDetailsPathRoute } from "./TakeFiveRoutes";
import './TakeFive.css'

const getTakeFiveHomeRoute = () => { return takeFiveRoute; }
const getTakeFiveSectionRoute = () => { return takeFiveSectionPathRoute; }
const getTakeFiveOverviewRoute = () => { return takeFiveOverviewPathRoute }
const getTakeFiveRoute = () => { return takeFivePathRoute; }
const getTakeFiveDetailsRoute = () => { return takeFiveDetailsPathRoute }

export const takeFiveHomePage = {
    label: "About Take 5",
    value: "railOpsHomePage",
    getRoute: getTakeFiveHomeRoute
} as ISelectOption;

export const takeFiveSection = {
    label: "Take 5",
    value: "takeFiveSection",
    getRoute: getTakeFiveSectionRoute
} as ISelectOption;

export const takeFive = {
    label: "Take 5 Form",
    value: "takeFive",
    getRoute: getTakeFiveRoute
} as ISelectOption;

export const takeFiveOverview = {
    label: "Overview",
    value: "takeFiveOverview",
    getRoute: getTakeFiveOverviewRoute
} as ISelectOption;

export const takeFiveDetails = {
    label: "Details",
    value: "takeFiveDetails",
    getRoute: getTakeFiveDetailsRoute,
    subitem: true
} as ISelectOption;

export const Tabs = {
    details: 'details',
    hazards: 'hazards',
}

interface TakeFivePageSelectorProps {
    selectedPage: ISelectOption
}

export const TakeFivePageSelector = (props: TakeFivePageSelectorProps) => {
    const [selectOptions, setSelectOptions] = useState<ISelectOption[]>([]);
    const navigate = useNavigate();
    const location = useLocation();

    const getSelectOptions = () => {
        var options: ISelectOption[] = [];
        options.push(takeFiveHomePage);
        options.push(takeFiveSection);
        options.push(takeFiveOverview);
        options.push(takeFiveDetails);

        return options;
    }

    const selectOnChange = (selectOption: ISelectOption) => {
        if (selectOption.value === props.selectedPage.value) {
            return; // Don't navigate if already on this page
        }

        var path = selectOption.getRoute().path;
        
        // Skip navigation if path contains route parameters (like :id, :dashboardType, etc)
        // or if we're on details page
        if (typeof (path) === 'string' && !path.includes(':') && props.selectedPage.value !== 'takeFiveDetails') {
            navigate(path);
        }
    }

    useEffect(() => {
        if (selectOptions.length === 0) {
            setSelectOptions(getSelectOptions());
        }
    }, []);

    return (
        <div className="take-five-selector-selector fa-narrow">
            <UncontrolledDropdown>
                <DropdownToggle tag="div" className="rbt-input-main form-control rbt-input">
                    <div className="tf-select-options">{props.selectedPage.label}</div>
                </DropdownToggle>
                <ExpandMore />
                <DropdownMenu className="tf-page-selector">
                    {selectOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`form-check-inline dropdown-item ${option.value}${option.subitem ? ' sub-item' : ''}`}
                            onClick={() => selectOnChange(option)}>
                            <Label className={`form-check-label`}>{option.label}</Label>
                        </div>

                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
};